import { Component } from '@angular/core';
import { ChatBotV2DataService } from '../../../services/chat-bot-v2/chat-bot-v2.data.service';

@Component({
  selector: 'app-chat-bot-asesor-v2-breadcrumbs',
  templateUrl: './chat-bot-asesor-v2-breadcrumbs.component.html',
})
export class ChatBotAsesorV2BreadcrumbsComponent { 
  constructor(
    public chatBotV2DS: ChatBotV2DataService,
  ) {}
}
